module.exports = __webpack_public_path__ + "img/dsci0021.9ef9ffdd.jpg";